import { Spinner } from '@frontend/components/common';
import React from 'react';
import { BarcodeFormat } from 'scanbot-web-sdk/@types';

import useScanbotScanner from './scanbot-scanner.controller';

const ID = 'scanbot-scanner';
export interface ScanbotScannerProps {
    callback?: (value: string) => void | Promise<void>;
    formats?: BarcodeFormat[];
}

export const ScanbotScanner = (props: ScanbotScannerProps) => {
    const viewProps = useScanbotScanner(props);

    return (
        <div
            id={ID}
            className='h-full w-full'>
            <div className={`relative h-full w-full bg-black`}>
                <div
                    ref={viewProps.divRef}
                    id='scanbot-scanner-video'
                    style={{ objectFit: 'cover', height: '100%', width: '100%' }}></div>

                {/* SDK initializing overlay */}
                {viewProps.sdkLoading && (
                    <div className='absolute inset-0 flex items-center justify-center bg-black/50'>
                        <Spinner className='text-border-default fill-brand-muted size-8' />
                    </div>
                )}

                {/* Loading overlay */}
                {viewProps.isLoading && (
                    <div
                        className={`absolute inset-0 flex items-center justify-center transition delay-50 ${viewProps.resultType === null ? 'bg-black/50' : viewProps.resultType === 'success' ? 'bg-status-success/50' : 'bg-status-danger/50'}`}>
                        <Spinner className='text-border-default fill-brand-muted size-8' />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScanbotScanner;
